'use client';

import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext, useEffect } from 'react';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';

export default function LoaderAnalytics() {
  const { trackEvent } = useContext(AnalyticsContext);

  useEffect(() => {
    trackEvent(ANALYTICS_EVENTS.LOADER.PAGE_RENDERED);
  }, [trackEvent]);

  return null;
}
